// extracted by mini-css-extract-plugin
module.exports = {"container":"aghanims-tooltip_container_uomEm","small":"aghanims-tooltip_small_1SEGe","invoker":"aghanims-tooltip_invoker_3tQnU","stem":"aghanims-tooltip_stem_3MYm2"};